import React from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import routes from 'app/routes';
import Form from '../Form/Index';
import { useContext } from '../../Context';

export default function Index() {
  const navigate = useNavigate();
  const { dispatch, actions } = useContext();

  const onSave = (values, successCallback, errorCallback) => {
    actions.add(dispatch, values, () => {
      successCallback();
    }, (errors) => {
      errorCallback(errors);
    });
  };

  return (
    <Modal
      className="student inmodal auto without-overflow"
      show
      onHide={() => navigate(routes.admin.resources.index)}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Create Resource
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSave={onSave} />
      </Modal.Body>
    </Modal>
  );
}
